module.exports = __webpack_public_path__ + "img/ep-tartine.bb396285.jpg";